<template>
  <table class="comp__table">
    <colgroup>
      <col class="comp__table-headings">
    </colgroup>
    <thead>
      <tr>
        <th></th>
        <th v-for="product in products" :key="product.id" class="comp__table-product">
          <CompareTableProductHeader
            :product="product"
            :getProductImage="getProductImage"
            :redirectToBottom="redirectToBottom"
            :onProductRemove="onProductRemove"
          />
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(headingData, index) in uniqueHeadings" :key="index">
        <tr v-if="headingData.key.toLowerCase() != 'buying options'">
          <td>{{ headingData.heading }}</td>
          <td v-for="(data, cIndex) in comparisonTable" :key="cIndex" :class="{'comp__table-td-multiple': data[headingData.key].length > 1}">
            <div v-if="headingData.key.toLowerCase() === 'ratings' && data[headingData.key][0].value.toLowerCase() === 'true'">
              <div class="yotpo-widget-instance" data-yotpo-instance-id="498880" :data-yotpo-product-id="data[headingData.key][0].productId"></div>
            </div>
            <div v-else-if="headingData.key.toLowerCase() === 'fabric' && data[headingData.key][0].value.toLowerCase() === 'true'">
              <div v-html="data[headingData.key][0].fabricDetails"></div>
            </div>
            <div v-else-if="headingData.key.toLowerCase() === 'measurements' && data[headingData.key][0].value.toLowerCase() === 'true'">
              <div v-html="data[headingData.key][0].measurementsDetails"></div>
            </div>
            <div v-else v-for="item in data[headingData.key]" :key="item.value">
              <div v-if="item.icon" class="comp__table-td-icon">
                <ImageField :obj="{'url': item.icon,'alt':'Icon Image', 'width':240,'height':240}"/>
                <span>{{ item.value }}</span>
              </div>
              <div v-else>{{ item.value }}</div>
            </div>  
          </td>
        </tr>
        <tr v-else>
          <td></td>
          <td id="buyingOptions" v-for="(product, pIndex) in products" :key="product.id">
            <CompareTableProductBuyingOptions
              :pIndex="pIndex"
              :product="product"
              :redirectToBottom="redirectToBottom"
              :getProductForm="getProductForm"
              :onOptionChange="onOptionChange"
            />
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script setup>
  import { toRefs, onMounted } from 'vue';
  import CompareTableProductHeader from './compare-table-product-header.vue';
  import CompareTableProductBuyingOptions from './compare-table-product-buying-options.vue';

  const props = defineProps({
    products: {
      type: Object,
      required: true,
    },

    uniqueHeadings: {
      type: Object,
      required: true,
    },

    comparisonTable: {
      type: Object,
      required: true,
    }
  })

  const { products, uniqueHeadings, comparisonTable } = toRefs(props)
  const emit = defineEmits(['on-remove-item']);

  onMounted(() => {
    window.refreshYotpoData();
  })

  const getProductForm = (product) => {
    return {
      Color: product.Color,
      Size: product.Size || null,
      Inseam: product.Inseam || null,
      Outseam: product.Outseam || null,
      selectedVariant: product.selectedVariant || null
    }
  }
  
  const onOptionChange = (key, value, index, length, productIndex) => {
    const product = products.value[productIndex];
    product[key] = value;

    // Setting  Variant Value
    const productForm = getProductForm(product);
    const variantValue = product.options.map(option => productForm[option.name]).join(' / ');
    const variant = product.variants.find(item => item.value === variantValue);
    product['selectedVariant'] = variant || null;

    // if(key != 'Color' && key != 'Title'){
    //   updateColorOOS(product, value,index,length)
    // }
  }

  const getProductImage = (product, color) => {
    if (color) {
      return product.variants.find(item => item.option1 === color)?.featured_image || pro
    }

    return product.featured_image;
  }

  const onProductRemove = (product) => {
    emit('on-remove-item', product);
  }

  const redirectToBottom = () => {
    document.querySelector('#buyingOptions').scrollIntoView({
      behavior: 'smooth'
    });
  };

</script>
